import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { toast } from "sonner";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  async function onSubmit(e) {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email.trim(), password);
      toast.success("Bem-vinda de volta.");
      navigate("/admin");
    } catch (err) {
      console.error(err);
      const detail = err?.response?.data?.detail;
      const msg = typeof detail === "string" ? detail : "Não foi possível autenticar.";
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen bg-offwhite flex flex-col">
      <header className="px-6 md:px-12 py-6 border-b border-fendi/60 flex items-center justify-between">
        <Link to="/" className="font-serif text-2xl text-softblack" data-testid="admin-login-logo">
          Hub<span className="text-champagne">.</span>
        </Link>
        <span className="eyebrow">Área restrita</span>
      </header>
      <main className="flex-1 flex items-center justify-center px-6 py-16">
        <form onSubmit={onSubmit} data-testid="admin-login-form" className="w-full max-w-md bg-white border border-fendi p-10">
          <p className="eyebrow">Acesso administrativo</p>
          <h1 className="font-serif text-4xl text-softblack mt-3">Entrar</h1>
          <p className="text-warmgray text-sm mt-3 font-light">
            Utilize suas credenciais para gerenciar leads, portfólio e depoimentos.
          </p>
          <div className="mt-10 space-y-6">
            <label className="block">
              <span className="eyebrow">E-mail</span>
              <input
                required type="email" data-testid="admin-login-email"
                className="editorial-field mt-3"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="admin@hub.com"
              />
            </label>
            <label className="block">
              <span className="eyebrow">Senha</span>
              <input
                required type="password" data-testid="admin-login-password"
                className="editorial-field mt-3"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
              />
            </label>
          </div>
          <button type="submit" disabled={loading} data-testid="admin-login-submit" className="btn-primary w-full mt-10 disabled:opacity-60">
            {loading ? "Entrando…" : "Entrar"}
          </button>
        </form>
      </main>
    </div>
  );
}
